module.exports = __webpack_public_path__ + "assets/media/3.f9affb0c.wav";